import styled from 'styled-components';

import { colors, radius } from '../../../../../../styles/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h3`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 4px;
`;

export const ToolButton = styled.button`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 16px;

  background-color: ${colors.sidebar};
  border: none;
  border-radius: ${radius.sm};
  cursor: pointer;

  color: ${colors.onSurface};

  transition: background-color 0.2s;

  span:first-child {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  &:hover:not(:disabled) {
    background-color: #361700;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const DangerButton = styled(ToolButton)`
  &:hover:not(:disabled) {
    background-color: ${colors.error}1a;
    color: ${colors.error};
  }
`;
